import { Component, Input, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../../shared/toast/toast.component';
import { AuthService } from '../../services/auth.service';
import { AlertService } from '../../services/alert.service';
import { Alert } from '../../shared/models/alert.model';
import { Commission } from '../../shared/models/commission.model';
import { ee, profilePics } from '../../shared/constants';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class AlertComponent implements OnInit {
  auth = inject(AuthService);
  private alertService = inject(AlertService);
  toast = inject(ToastComponent);


  @Input() alert: Alert;
  @Input() commissions: Commission[];

  isEditAlertModalVisible = false;
  iAmParticipant = false;
  canEditAnyAlert = false;
  profilePics = profilePics;

  ngOnInit(): void {
    const usersIds = this.alert._users.map(user => user._id);
    this.iAmParticipant = usersIds.includes(this.auth.currentUser._id);
    this.canEditAnyAlert = this.auth.currentUser.permissions.includes('editAnyAlert');
  }

  runAlertQuery(alert: Alert): void {
    ee.emit('runAlertQuery', alert);
  }

  toggleEditAlertModal(alert: Alert): void {
    this.isEditAlertModalVisible = true;
    ee.emit('showEditAlertModal', alert);
  }

  deleteAlert(alert: Alert): void {
    if (window.confirm(`Are you sure you want to delete ${alert.name}?`)) {
      this.alertService.delete(alert)
        .pipe(finalize(() => ee.emit('getAlerts')))
        .subscribe({
          next: res => this.toast.setMessage('Alert deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger'),
        });
    }
  }

}
